import script from "./OperatorApplicationDialogHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationDialogHistory.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationDialogHistory.vue?vue&type=style&index=0&id=3fa80d7f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa80d7f"]])

export default __exports__